import { cn } from "@/lib/utils";

interface ForgedLineProps {
  variant?: "horizontal" | "vertical" | "divider" | "trinity";
  className?: string;
  width?: string;
}

export const ForgedLine = ({ variant = "horizontal", className, width }: ForgedLineProps) => {
  if (variant === "vertical") {
    return (
      <div
        className={cn("w-[3px] bg-accent rounded-full", className)}
        style={{
          backgroundImage: `repeating-linear-gradient(
            180deg,
            hsl(var(--accent)) 0px,
            hsl(var(--accent) / 0.7) 2px,
            hsl(var(--accent)) 4px
          )`,
          height: width || "60px",
        }}
      />
    );
  }

  if (variant === "divider") {
    return (
      <div
        className={cn("h-[2px] mx-auto", className)}
        style={{
          width: width || "60px",
          background: `linear-gradient(90deg, transparent, hsl(var(--accent)), transparent)`,
        }}
      />
    );
  }

  // Trinity — three parallel lines representing the Trinity
  if (variant === "trinity") {
    return (
      <div className={cn("flex flex-col items-start gap-[5px]", className)} role="img" aria-label="Trinity lines">
        <div
          className="h-[2px] rounded-full"
          style={{
            width: width || "48px",
            background: `linear-gradient(90deg, hsl(var(--accent)), hsl(var(--accent) / 0.3))`,
          }}
        />
        <div
          className="h-[2px] rounded-full"
          style={{
            width: `calc(${width || "48px"} * 0.7)`,
            background: `linear-gradient(90deg, hsl(var(--accent) / 0.8), hsl(var(--accent) / 0.2))`,
          }}
        />
        <div
          className="h-[2px] rounded-full"
          style={{
            width: `calc(${width || "48px"} * 0.45)`,
            background: `linear-gradient(90deg, hsl(var(--accent) / 0.6), hsl(var(--accent) / 0.1))`,
          }}
        />
      </div>
    );
  }

  // horizontal
  return (
    <div
      className={cn("h-[1px]", className)}
      style={{
        width: width || "40px",
        backgroundImage: `repeating-linear-gradient(
          90deg,
          hsl(var(--accent)) 0px,
          hsl(var(--accent) / 0.6) 3px,
          hsl(var(--accent)) 6px
        )`,
      }}
    />
  );
};
